export default "__VITE_ASSET__D1rT5fYZ__"